import type { CategoryType, DipseaContentType } from '../flowTypes'
import { sortSlugs } from './helpers'
import {
  getAllCategoriesByTypeAsync,
  getCategoryByIdAsync,
  getCategoryBySlugAsync,
  getEpisodeInformation
} from './Category'
import type { TrackPropsType } from './Track'
import { getLibrary } from '../services/dipseaApi'
import { convertTrackToProps } from './Track'

export type CreatorInfoPropsType = {
  title: string,
  logLine?: string,
  description: string,
  id: string,
  episodeInfo: string,
  imageUrl: string,
  slug: string
}

export type CreatorPropsType = CreatorInfoPropsType & {
  tracks: TrackPropsType[]
}

export type CreatorListPropsType = {
  title: string,
  description: string,
  creators: CreatorInfoPropsType[]
}

export const creatorCategoryId = '-NTo9mOyS5_Apr9V3G2n'

export async function convertCreatorCategoryToListProps (): Promise<CreatorListPropsType> {
  const [creatorCategory, creators] = await Promise.all([getCategoryByIdAsync(creatorCategoryId), getAllCategoriesByTypeAsync('creator')])
  return {
    title: creatorCategory.display_name,
    description: creatorCategory.description,
    creators: creators.map((creator: CategoryType): CreatorInfoPropsType => convertCreatorToInfoProps(creator))
  }
}

export function convertCreatorToInfoProps (category: CategoryType): CreatorInfoPropsType {
  const slug = sortSlugs(category.slugs)[0]
  return {
    title: category.display_name,
    logLine: category.short_description,
    description: category.description,
    id: category.id,
    episodeInfo: getEpisodeInformation(category, 'Audio'),
    imageUrl: category.image_url,
    slug: `/creators/${slug}`
  }
}
export function convertCreatorToProps (category: CategoryType, library: DipseaContentType): CreatorPropsType {
  const tracks = Object.keys(category.track_index || {})
    .sort((a: string, b: string): number => (category.track_index[a].index - category.track_index[b].index))
    .map((key: string): TrackPropsType => convertTrackToProps(library.tracks[key], library))
    .filter((track: TrackPropsType | null): track is TrackPropsType => !!track)
  const slug = sortSlugs(category.slugs)[0]
  return {
    title: category.display_name,
    logLine: category.short_description,
    description: category.description,
    id: category.id,
    episodeInfo: getEpisodeInformation(category, 'Audio'),
    imageUrl: category.image_url,
    tracks,
    slug: `/creators/${slug}`
  }
}

export async function convertCreatorBySlugToProps (slug: string): Promise<CreatorPropsType> {
  const [category, library] = await Promise.all([getCategoryBySlugAsync(slug), getLibrary()])
  return convertCreatorToProps(category, library)
}

export async function convertCreatorByIdToProps (id: string): Promise<CreatorPropsType> {
  const [category, library] = await Promise.all([getCategoryBySlugAsync(id), getLibrary()])
  return convertCreatorToProps(category, library)
}
